var map = {
	"./piece_level0.png": "Aq6S",
	"./piece_level1.png": "/8f6",
	"./piece_level2.png": "HqFa"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "34MQ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/piece ^\.\/piece_level.*\.png$
// module id = 34MQ
// module chunks = 0